import { useContext, useEffect } from 'react';
import { useHistory } from 'react-router';

import { AuthContext } from './authContext';

export const useRedirectIfLoggedIn = () => {
  const { isLoggedIn, isAuthChecking } = useContext(AuthContext);
  const history = useHistory();

  useEffect(() => {
    if (isAuthChecking) return;
    // 既にログイン済ならトップページへ
    if (isLoggedIn) {
      history.replace('/project');
    }
  }, [isLoggedIn, isAuthChecking]);
};
